import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription, first } from 'rxjs';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { environment } from 'src/environments/environment';
import { PatientManagerTableComponent } from '../patient-manager-table/patient-manager-table.component';
import { PMPatientListItem } from 'src/patient-manager/common/models/internal/pm-patient-list-item.model';
import { PMDialogsManagerService } from 'src/patient-manager/services/pm-dialogs-manager.service';
import { PatientManagerListService } from 'src/patient-manager/services/patient-manager-list.service';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import buildDate from '../../../../buildDate.json';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-patient-manager',
    templateUrl: './patient-manager.component.html',
    styleUrls: ['./patient-manager.component.css'],
    standalone: false
})
export class PatientManagerComponent {
  patient_manager_version = "1.1.5"
  subscription: Subscription = new Subscription()

  public environmentName = environment.name
  public buildDateTime =buildDate.timestamp

  search: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true })


  searchListSource: PMPatientListItem[] = []
  searchPatientListSource: string[] = []

  searchWasEmpty = true

  @ViewChild('patientManagerTable') homeTable: PatientManagerTableComponent = {} as PatientManagerTableComponent;

  CountriesEnum = CountriesEnum
  CountriesIDs = COUNTRIES_IDS


  constructor(private dialogsManagerService: PMDialogsManagerService, private patientManagerListService: PatientManagerListService,
    private serverValueInterpreterService: ServerValueInterpreterService)
  {
  }

  ngOnDestroy(): void
  {
    this.patientManagerListService.clearAll()
  }


  ngOnInit(): void
  {
    this.getCountryFromStorage()


    this.patientManagerListService.loadedPatientListSubject.pipe(first(l_loaded => l_loaded == true)).subscribe(() =>
    {

      this.searchListSource = this.patientManagerListService.data

      let l_patients: string[] = this.patientManagerListService.data.map(function (item)
      {
        return item.patientId ? item.patientId : ''
      })

      this.searchPatientListSource = [...new Set(l_patients)]

      this.search.enable()
    })

    let l_sub = this.search.valueChanges.subscribe(l_change =>
    {
      if (!(this.searchWasEmpty && l_change == ''))
      {
        this.filterByIdCityOrName(l_change)
        if (l_change == '')
        {
          this.searchWasEmpty = true
        } else
        {
          this.searchWasEmpty = false
        }


      }
    })


    this.subscription.add(l_sub)
  }



  filterByIdCityOrName(input: string)
  {
    this.patientManagerListService.filterByIdEmailOrName.next(input)
  }

  getCountryFromStorage()
  {
    let l_country = localStorage.getItem('default_country_patient_manager')
    if (l_country && Object.keys(COUNTRIES_IDS).includes(l_country))
    {
      this.setInnerCountryFilter(l_country as CountryId)
    }
  }

  setCountryFilter(country: CountryId)
  {
    this.saveCountryToLocalStorage(country)
    this.setInnerCountryFilter(country)
  }

  setInnerCountryFilter(country: CountryId)
  {
    this.patientManagerListService.tableSettings.countryFilterState = country;
    this.patientManagerListService.filterByCountry.next(country)
  }

  saveCountryToLocalStorage(country: CountryId)
  {
    localStorage.setItem('default_country_patient_manager', country)
  }

  getShownCountry(): string
  {
    const countryFilter = this.patientManagerListService.tableSettings.countryFilterState;
    if (countryFilter && Object.values(COUNTRIES_IDS).includes(countryFilter))
      return this.serverValueInterpreterService.getFullCountryNameById(countryFilter)
    else return 'No country selected'

  }

  getFullCountryNameById(countryId: CountryId): CountriesEnum
  {
    return this.serverValueInterpreterService.getFullCountryNameById(countryId)
  }

  generateReleaseCodes(){
    this.dialogsManagerService.showGenerateCodesCSVDialogComponent();
  }
}
